import { render, staticRenderFns } from "./numberType.vue?vue&type=template&id=1bb41cb0&scoped=true&"
import script from "./numberType.vue?vue&type=script&lang=js&"
export * from "./numberType.vue?vue&type=script&lang=js&"
import style0 from "./numberType.vue?vue&type=style&index=0&id=1bb41cb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb41cb0",
  null
  
)

export default component.exports